@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

val skillCombo_1 = AbilitySkillId(1)
val skillShoulderTackle_2 = AbilitySkillId(2)
val skillOneInchPunch_3 = AbilitySkillId(3)
val skillBackhandBlow_4 = AbilitySkillId(4)
val skillRagingFists_5 = AbilitySkillId(5)
val skillSpinningAttack_6 = AbilitySkillId(6)
val skillHowlingFist_7 = AbilitySkillId(7)
val skillDragonKick_8 = AbilitySkillId(8)
val skillAsuranFists_9 = AbilitySkillId(9)
val skillFinalHeaven_10 = AbilitySkillId(10)
val skillAsceticsFury_11 = AbilitySkillId(11)
val skillStringingPummel_12 = AbilitySkillId(12)
val skillTornadoKick_13 = AbilitySkillId(13)
val skillVictorySmite_14 = AbilitySkillId(14)
val skillShijinSpiral_15 = AbilitySkillId(15)
val skillWaspSting_16 = AbilitySkillId(16)
val skillViperBite_17 = AbilitySkillId(17)
val skillShadowstitch_18 = AbilitySkillId(18)
val skillGustSlash_19 = AbilitySkillId(19)
val skillCyclone_20 = AbilitySkillId(20)
val skillEnergySteal_21 = AbilitySkillId(21)
val skillEnergyDrain_22 = AbilitySkillId(22)
val skillDancingEdge_23 = AbilitySkillId(23)
val skillSharkBite_24 = AbilitySkillId(24)
val skillEvisceration_25 = AbilitySkillId(25)
val skillMercyStroke_26 = AbilitySkillId(26)
val skillMandalicStab_27 = AbilitySkillId(27)
val skillMordantRime_28 = AbilitySkillId(28)
val skillPyrrhicKleos_29 = AbilitySkillId(29)
val skillAeolianEdge_30 = AbilitySkillId(30)
val skillRudrasStorm_31 = AbilitySkillId(31)
val skillFastBlade_32 = AbilitySkillId(32)
val skillBurningBlade_33 = AbilitySkillId(33)
val skillRedLotusBlade_34 = AbilitySkillId(34)
val skillFlatBlade_35 = AbilitySkillId(35)
val skillShiningBlade_36 = AbilitySkillId(36)
val skillSeraphBlade_37 = AbilitySkillId(37)
val skillCircleBlade_38 = AbilitySkillId(38)
val skillSpiritsWithin_39 = AbilitySkillId(39)
val skillVorpalBlade_40 = AbilitySkillId(40)
val skillSwiftBlade_41 = AbilitySkillId(41)
val skillSavageBlade_42 = AbilitySkillId(42)
val skillKnightsofRound_43 = AbilitySkillId(43)
val skillDeathBlossom_44 = AbilitySkillId(44)
val skillAtonement_45 = AbilitySkillId(45)
val skillExpiacion_46 = AbilitySkillId(46)
val skillSanguineBlade_47 = AbilitySkillId(47)
val skillHardSlash_48 = AbilitySkillId(48)
val skillPowerSlash_49 = AbilitySkillId(49)
val skillFrostbite_50 = AbilitySkillId(50)
val skillFreezebite_51 = AbilitySkillId(51)
val skillShockwave_52 = AbilitySkillId(52)
val skillCrescentMoon_53 = AbilitySkillId(53)
val skillSickleMoon_54 = AbilitySkillId(54)
val skillSpinningSlash_55 = AbilitySkillId(55)
val skillGroundStrike_56 = AbilitySkillId(56)
val skillScourge_57 = AbilitySkillId(57)
val skillHerculeanSlash_58 = AbilitySkillId(58)
val skillTorcleaver_59 = AbilitySkillId(59)
val skillResolution_60 = AbilitySkillId(60)
val skillDimidiation_61 = AbilitySkillId(61)
val skillFimbulvetr_62 = AbilitySkillId(62)
val skillRagingAxe_64 = AbilitySkillId(64)
val skillSmashAxe_65 = AbilitySkillId(65)
val skillGaleAxe_66 = AbilitySkillId(66)
val skillAvalancheAxe_67 = AbilitySkillId(67)
val skillSpinningAxe_68 = AbilitySkillId(68)
val skillRampage_69 = AbilitySkillId(69)
val skillCalamity_70 = AbilitySkillId(70)
val skillMistralAxe_71 = AbilitySkillId(71)
val skillDecimation_72 = AbilitySkillId(72)
val skillOnslaught_73 = AbilitySkillId(73)
val skillPrimalRend_74 = AbilitySkillId(74)
val skillBoraAxe_75 = AbilitySkillId(75)
val skillCloudsplitter_76 = AbilitySkillId(76)
val skillRuinator_77 = AbilitySkillId(77)
val skillBlitz_78 = AbilitySkillId(78)
val skillShieldBreak_80 = AbilitySkillId(80)
val skillIronTempest_81 = AbilitySkillId(81)
val skillSturmwind_82 = AbilitySkillId(82)
val skillArmorBreak_83 = AbilitySkillId(83)
val skillKeenEdge_84 = AbilitySkillId(84)
val skillWeaponBreak_85 = AbilitySkillId(85)
val skillRagingRush_86 = AbilitySkillId(86)
val skillFullBreak_87 = AbilitySkillId(87)
val skillSteelCyclone_88 = AbilitySkillId(88)
val skillMetatronTorment_89 = AbilitySkillId(89)
val skillKingsJustice_90 = AbilitySkillId(90)
val skillFellCleave_91 = AbilitySkillId(91)
val skillUkkosFury_92 = AbilitySkillId(92)
val skillUpheaval_93 = AbilitySkillId(93)
val skillDisaster_94 = AbilitySkillId(94)
val skillSlice_96 = AbilitySkillId(96)
val skillDarkHarvest_97 = AbilitySkillId(97)
val skillShadowofDeath_98 = AbilitySkillId(98)
val skillNightmareScythe_99 = AbilitySkillId(99)
val skillSpinningScythe_100 = AbilitySkillId(100)
val skillVorpalScythe_101 = AbilitySkillId(101)
val skillGuillotine_102 = AbilitySkillId(102)
val skillCrossReaper_103 = AbilitySkillId(103)
val skillSpiralHell_104 = AbilitySkillId(104)
val skillCatastrophe_105 = AbilitySkillId(105)
val skillInsurgency_106 = AbilitySkillId(106)
val skillInfernalScythe_107 = AbilitySkillId(107)
val skillQuietus_108 = AbilitySkillId(108)
val skillEntropy_109 = AbilitySkillId(109)
val skillOrigin_110 = AbilitySkillId(110)
val skillDoubleThrust_112 = AbilitySkillId(112)
val skillThunderThrust_113 = AbilitySkillId(113)
val skillRaidenThrust_114 = AbilitySkillId(114)
val skillLegSweep_115 = AbilitySkillId(115)
val skillPentaThrust_116 = AbilitySkillId(116)
val skillVorpalThrust_117 = AbilitySkillId(117)
val skillSkewer_118 = AbilitySkillId(118)
val skillWheelingThrust_119 = AbilitySkillId(119)
val skillImpulseDrive_120 = AbilitySkillId(120)
val skillGeirskogul_121 = AbilitySkillId(121)
val skillDrakesbane_122 = AbilitySkillId(122)
val skillSonicThrust_123 = AbilitySkillId(123)
val skillCamlannsTorment_124 = AbilitySkillId(124)
val skillStardiver_125 = AbilitySkillId(125)
val skillDiarmuid_126 = AbilitySkillId(126)
val skillBladeRin_128 = AbilitySkillId(128)
val skillBladeRetsu_129 = AbilitySkillId(129)
val skillBladeTeki_130 = AbilitySkillId(130)
val skillBladeTo_131 = AbilitySkillId(131)
val skillBladeChi_132 = AbilitySkillId(132)
val skillBladeEi_133 = AbilitySkillId(133)
val skillBladeJin_134 = AbilitySkillId(134)
val skillBladeTen_135 = AbilitySkillId(135)
val skillBladeKu_136 = AbilitySkillId(136)
val skillBladeMetsu_137 = AbilitySkillId(137)
val skillBladeKamu_138 = AbilitySkillId(138)
val skillBladeYu_139 = AbilitySkillId(139)
val skillBladeHi_140 = AbilitySkillId(140)
val skillBladeShun_141 = AbilitySkillId(141)
val skillZeshoMeppo_142 = AbilitySkillId(142)
val skillTachiEnpi_144 = AbilitySkillId(144)
val skillTachiHobaku_145 = AbilitySkillId(145)
val skillTachiGoten_146 = AbilitySkillId(146)
val skillTachiKagero_147 = AbilitySkillId(147)
val skillTachiJinpu_148 = AbilitySkillId(148)
val skillTachiKoki_149 = AbilitySkillId(149)
val skillTachiYukikaze_150 = AbilitySkillId(150)
val skillTachiGekko_151 = AbilitySkillId(151)
val skillTachiKasha_152 = AbilitySkillId(152)
val skillTachiKaiten_153 = AbilitySkillId(153)
val skillTachiRana_154 = AbilitySkillId(154)
val skillTachiAgeha_155 = AbilitySkillId(155)
val skillTachiFudo_156 = AbilitySkillId(156)
val skillTachiShoha_157 = AbilitySkillId(157)
val skillTachiSuikawari_158 = AbilitySkillId(158)
val skillTachiMumei_159 = AbilitySkillId(159)
val skillShiningStrike_160 = AbilitySkillId(160)
val skillSeraphStrike_161 = AbilitySkillId(161)
val skillBrainshaker_162 = AbilitySkillId(162)
val skillStarlight_163 = AbilitySkillId(163)
val skillMoonlight_164 = AbilitySkillId(164)
val skillSkullbreaker_165 = AbilitySkillId(165)
val skillTrueStrike_166 = AbilitySkillId(166)
val skillJudgment_167 = AbilitySkillId(167)
val skillHexaStrike_168 = AbilitySkillId(168)
val skillBlackHalo_169 = AbilitySkillId(169)
val skillRandgrith_170 = AbilitySkillId(170)
val skillMysticBoon_171 = AbilitySkillId(171)
val skillFlashNova_172 = AbilitySkillId(172)
val skillDagan_173 = AbilitySkillId(173)
val skillRealmrazer_174 = AbilitySkillId(174)
val skillExudation_175 = AbilitySkillId(175)
val skillHeavySwing_176 = AbilitySkillId(176)
val skillRockCrusher_177 = AbilitySkillId(177)
val skillEarthCrusher_178 = AbilitySkillId(178)
val skillStarburst_179 = AbilitySkillId(179)
val skillSunburst_180 = AbilitySkillId(180)
val skillShellCrusher_181 = AbilitySkillId(181)
val skillFullSwing_182 = AbilitySkillId(182)
val skillSpiritTaker_183 = AbilitySkillId(183)
val skillRetribution_184 = AbilitySkillId(184)
val skillGateofTartarus_185 = AbilitySkillId(185)
val skillVidohunir_186 = AbilitySkillId(186)
val skillGarlandofBliss_187 = AbilitySkillId(187)
val skillOmniscience_188 = AbilitySkillId(188)
val skillCataclysm_189 = AbilitySkillId(189)
val skillMyrkr_190 = AbilitySkillId(190)
val skillShattersoul_191 = AbilitySkillId(191)
val skillFlamingArrow_192 = AbilitySkillId(192)
val skillPiercingArrow_193 = AbilitySkillId(193)
val skillDullingArrow_194 = AbilitySkillId(194)
val skillSidewinder_196 = AbilitySkillId(196)
val skillBlastArrow_197 = AbilitySkillId(197)
val skillArchingArrow_198 = AbilitySkillId(198)
val skillEmpyrealArrow_199 = AbilitySkillId(199)
val skillNamasArrow_200 = AbilitySkillId(200)
val skillRefulgentArrow_201 = AbilitySkillId(201)
val skillJishnusRadiance_202 = AbilitySkillId(202)
val skillApexArrow_203 = AbilitySkillId(203)
val skillSarv_204 = AbilitySkillId(204)
val skillHotShot_208 = AbilitySkillId(208)
val skillSplitShot_209 = AbilitySkillId(209)
val skillSniperShot_210 = AbilitySkillId(210)
val skillSlugShot_212 = AbilitySkillId(212)
val skillBlastShot_213 = AbilitySkillId(213)
val skillHeavyShot_214 = AbilitySkillId(214)
val skillDetonator_215 = AbilitySkillId(215)
val skillCoronach_216 = AbilitySkillId(216)
val skillTrueflight_217 = AbilitySkillId(217)
val skillLeadenSalute_218 = AbilitySkillId(218)
val skillNumbingShot_219 = AbilitySkillId(219)
val skillWildfire_220 = AbilitySkillId(220)
val skillLastStand_221 = AbilitySkillId(221)
val skillTerminus_222 = AbilitySkillId(222)
val skillExenterator_224 = AbilitySkillId(224)
val skillChantduCygne_225 = AbilitySkillId(225)
val skillRequiescat_226 = AbilitySkillId(226)
val skillKnightsofRotund_227 = AbilitySkillId(227)
val skillFinalParadise_228 = AbilitySkillId(228)
val skillFastBladeII_229 = AbilitySkillId(229)
val skillDragonBlow_230 = AbilitySkillId(230)
val skillMaruKala_231 = AbilitySkillId(231)
val skillRuthlessStroke_232 = AbilitySkillId(232)
val skillImperator_233 = AbilitySkillId(233)
val skillDagda_234 = AbilitySkillId(234)
val skillOshala_235 = AbilitySkillId(235)
val skillUrielBlade_238 = AbilitySkillId(238)
val skillGlorySlash_239 = AbilitySkillId(239)
val skillTartarusTorpor_240 = AbilitySkillId(240)
val skillNetherspikes_241 = AbilitySkillId(241)
val skillCarnalNightmare_242 = AbilitySkillId(242)
val skillAegisSchism_243 = AbilitySkillId(243)
val skillDancingChains_244 = AbilitySkillId(244)
val skillBarbedCrescent_245 = AbilitySkillId(245)
val skillShackledFists_246 = AbilitySkillId(246)
val skillFoxfire_247 = AbilitySkillId(247)
val skillGrimHalo_248 = AbilitySkillId(248)
val skillNetherspikes_249 = AbilitySkillId(249)
val skillCarnalNightmare_250 = AbilitySkillId(250)
val skillAegisSchism_251 = AbilitySkillId(251)
val skillDancingChains_252 = AbilitySkillId(252)
val skillBarbedCrescent_253 = AbilitySkillId(253)
val skillVulcanShot_254 = AbilitySkillId(254)
val skillDimensionalDeath_255 = AbilitySkillId(255)
val skillMightyStrikes_528 = AbilitySkillId(528)
val skillHundredFists_529 = AbilitySkillId(529)
val skillBenediction_530 = AbilitySkillId(530)
val skillManafont_531 = AbilitySkillId(531)
val skillChainspell_532 = AbilitySkillId(532)
val skillPerfectDodge_533 = AbilitySkillId(533)
val skillInvincible_534 = AbilitySkillId(534)
val skillBloodWeapon_535 = AbilitySkillId(535)
val skillFamiliar_536 = AbilitySkillId(536)
val skillSoulVoice_537 = AbilitySkillId(537)
val skillEagleEyeShot_538 = AbilitySkillId(538)
val skillMeikyoShisui_539 = AbilitySkillId(539)
val skillMijinGakure_540 = AbilitySkillId(540)
val skillSpiritSurge_541 = AbilitySkillId(541)
val skillAstralFlow_542 = AbilitySkillId(542)
val skillBerserk_543 = AbilitySkillId(543)
val skillWarcry_544 = AbilitySkillId(544)
val skillDefender_545 = AbilitySkillId(545)
val skillAggressor_546 = AbilitySkillId(546)
val skillProvoke_547 = AbilitySkillId(547)
val skillFocus_548 = AbilitySkillId(548)
val skillDodge_549 = AbilitySkillId(549)
val skillChakra_550 = AbilitySkillId(550)
val skillBoost_551 = AbilitySkillId(551)
val skillCounterstance_552 = AbilitySkillId(552)
val skillSteal_553 = AbilitySkillId(553)
val skillFlee_554 = AbilitySkillId(554)
val skillHide_555 = AbilitySkillId(555)
val skillSneakAttack_556 = AbilitySkillId(556)
val skillMug_557 = AbilitySkillId(557)
val skillShieldBash_558 = AbilitySkillId(558)
val skillHolyCircle_559 = AbilitySkillId(559)
val skillSentinel_560 = AbilitySkillId(560)
val skillSouleater_561 = AbilitySkillId(561)
val skillArcaneCircle_562 = AbilitySkillId(562)
val skillLastResort_563 = AbilitySkillId(563)
val skillCharm_564 = AbilitySkillId(564)
val skillGauge_565 = AbilitySkillId(565)
val skillTame_566 = AbilitySkillId(566)
val skillPetcommands_567 = AbilitySkillId(567)
val skillScavenge_568 = AbilitySkillId(568)
val skillShadowbind_569 = AbilitySkillId(569)
val skillCamouflage_570 = AbilitySkillId(570)
val skillSharpshot_571 = AbilitySkillId(571)
val skillBarrage_572 = AbilitySkillId(572)
val skillCallWyvern_573 = AbilitySkillId(573)
val skillThirdEye_574 = AbilitySkillId(574)
val skillMeditate_575 = AbilitySkillId(575)
val skillWardingCircle_576 = AbilitySkillId(576)
val skillAncientCircle_577 = AbilitySkillId(577)
val skillJump_578 = AbilitySkillId(578)
val skillHighJump_579 = AbilitySkillId(579)
val skillSuperJump_580 = AbilitySkillId(580)
val skillFight_581 = AbilitySkillId(581)
val skillHeel_582 = AbilitySkillId(582)
val skillLeave_583 = AbilitySkillId(583)
val skillSic_584 = AbilitySkillId(584)
val skillStay_585 = AbilitySkillId(585)
val skillDivineSeal_586 = AbilitySkillId(586)
val skillElementalSeal_587 = AbilitySkillId(587)
val skillTrickAttack_588 = AbilitySkillId(588)
val skillWeaponBash_589 = AbilitySkillId(589)
val skillReward_590 = AbilitySkillId(590)
val skillCover_591 = AbilitySkillId(591)
val skillSpiritLink_592 = AbilitySkillId(592)
val skillEnrage_593 = AbilitySkillId(593)
val skillChiBlast_594 = AbilitySkillId(594)
val skillConvert_595 = AbilitySkillId(595)
val skillAccomplice_596 = AbilitySkillId(596)
val skillCallBeast_597 = AbilitySkillId(597)
val skillUnlimitedShot_598 = AbilitySkillId(598)
val skillDismiss_599 = AbilitySkillId(599)
val skillAssault_600 = AbilitySkillId(600)
val skillRetreat_601 = AbilitySkillId(601)
val skillRelease_602 = AbilitySkillId(602)
val skillBloodPactRage_603 = AbilitySkillId(603)
val skillRampart_604 = AbilitySkillId(604)
val skillAzureLore_605 = AbilitySkillId(605)
val skillChainAffinity_606 = AbilitySkillId(606)
val skillBurstAffinity_607 = AbilitySkillId(607)
val skillWildCard_608 = AbilitySkillId(608)
val skillPhantomRoll_609 = AbilitySkillId(609)
val skillFightersRoll_610 = AbilitySkillId(610)
val skillMonksRoll_611 = AbilitySkillId(611)
val skillHealersRoll_612 = AbilitySkillId(612)
val skillWizardsRoll_613 = AbilitySkillId(613)
val skillWarlocksRoll_614 = AbilitySkillId(614)
val skillRoguesRoll_615 = AbilitySkillId(615)
val skillGallantsRoll_616 = AbilitySkillId(616)
val skillChaosRoll_617 = AbilitySkillId(617)
val skillBeastRoll_618 = AbilitySkillId(618)
val skillChoralRoll_619 = AbilitySkillId(619)
val skillHuntersRoll_620 = AbilitySkillId(620)
val skillSamuraiRoll_621 = AbilitySkillId(621)
val skillNinjaRoll_622 = AbilitySkillId(622)
val skillDrachenRoll_623 = AbilitySkillId(623)
val skillEvokersRoll_624 = AbilitySkillId(624)
val skillMagussRoll_625 = AbilitySkillId(625)
val skillCorsairsRoll_626 = AbilitySkillId(626)
val skillPuppetRoll_627 = AbilitySkillId(627)
val skillDancersRoll_628 = AbilitySkillId(628)
val skillScholarsRoll_629 = AbilitySkillId(629)
val skillBoltersRoll_630 = AbilitySkillId(630)
val skillCastersRoll_631 = AbilitySkillId(631)
val skillCoursersRoll_632 = AbilitySkillId(632)
val skillBlitzersRoll_633 = AbilitySkillId(633)
val skillTacticiansRoll_634 = AbilitySkillId(634)
val skillDoubleUp_635 = AbilitySkillId(635)
val skillQuickDraw_636 = AbilitySkillId(636)
val skillFireShot_637 = AbilitySkillId(637)
val skillIceShot_638 = AbilitySkillId(638)
val skillWindShot_639 = AbilitySkillId(639)
val skillEarthShot_640 = AbilitySkillId(640)
val skillThunderShot_641 = AbilitySkillId(641)
val skillWaterShot_642 = AbilitySkillId(642)
val skillLightShot_643 = AbilitySkillId(643)
val skillDarkShot_644 = AbilitySkillId(644)
val skillRandomDeal_645 = AbilitySkillId(645)
val skillOverdrive_647 = AbilitySkillId(647)
val skillActivate_648 = AbilitySkillId(648)
val skillRepair_649 = AbilitySkillId(649)
val skillDeploy_650 = AbilitySkillId(650)
val skillDeactivate_651 = AbilitySkillId(651)
val skillRetrieve_652 = AbilitySkillId(652)
val skillFireManeuver_653 = AbilitySkillId(653)
val skillIceManeuver_654 = AbilitySkillId(654)
val skillWindManeuver_655 = AbilitySkillId(655)
val skillEarthManeuver_656 = AbilitySkillId(656)
val skillThunderManeuver_657 = AbilitySkillId(657)
val skillWaterManeuver_658 = AbilitySkillId(658)
val skillLightManeuver_659 = AbilitySkillId(659)
val skillDarkManeuver_660 = AbilitySkillId(660)
val skillWarriorsCharge_661 = AbilitySkillId(661)
val skillTomahawk_662 = AbilitySkillId(662)
val skillMantra_663 = AbilitySkillId(663)
val skillFormlessStrikes_664 = AbilitySkillId(664)
val skillMartyr_665 = AbilitySkillId(665)
val skillDevotion_666 = AbilitySkillId(666)
val skillAssassinsCharge_667 = AbilitySkillId(667)
val skillFeint_668 = AbilitySkillId(668)
val skillFealty_669 = AbilitySkillId(669)
val skillChivalry_670 = AbilitySkillId(670)
val skillDarkSeal_671 = AbilitySkillId(671)
val skillDiabolicEye_672 = AbilitySkillId(672)
val skillFeralHowl_673 = AbilitySkillId(673)
val skillKillerInstinct_674 = AbilitySkillId(674)
val skillNightingale_675 = AbilitySkillId(675)
val skillTroubadour_676 = AbilitySkillId(676)
val skillStealthShot_677 = AbilitySkillId(677)
val skillFlashyShot_678 = AbilitySkillId(678)
val skillShikikoyo_679 = AbilitySkillId(679)
val skillBladeBash_680 = AbilitySkillId(680)
val skillDeepBreathing_681 = AbilitySkillId(681)
val skillAngon_682 = AbilitySkillId(682)
val skillSange_683 = AbilitySkillId(683)
val skillBloodPactWard_684 = AbilitySkillId(684)
val skillHasso_685 = AbilitySkillId(685)
val skillSeigan_686 = AbilitySkillId(686)
val skillConvergence_687 = AbilitySkillId(687)
val skillDiffusion_688 = AbilitySkillId(688)
val skillSnakeEye_689 = AbilitySkillId(689)
val skillFold_690 = AbilitySkillId(690)
val skillRoleReversal_691 = AbilitySkillId(691)
val skillVentriloquy_692 = AbilitySkillId(692)
val skillTrance_693 = AbilitySkillId(693)
val skillSambas_694 = AbilitySkillId(694)
val skillWaltzes_695 = AbilitySkillId(695)
val skillDrainSamba_696 = AbilitySkillId(696)
val skillDrainSambaII_697 = AbilitySkillId(697)
val skillDrainSambaIII_698 = AbilitySkillId(698)
val skillAspirSamba_699 = AbilitySkillId(699)
val skillAspirSambaII_700 = AbilitySkillId(700)
val skillHasteSamba_701 = AbilitySkillId(701)
val skillCuringWaltz_702 = AbilitySkillId(702)
val skillCuringWaltzII_703 = AbilitySkillId(703)
val skillCuringWaltzIII_704 = AbilitySkillId(704)
val skillCuringWaltzIV_705 = AbilitySkillId(705)
val skillHealingWaltz_706 = AbilitySkillId(706)
val skillDivineWaltz_707 = AbilitySkillId(707)
val skillSpectralJig_708 = AbilitySkillId(708)
val skillChocoboJig_709 = AbilitySkillId(709)
val skillJigs_710 = AbilitySkillId(710)
val skillSteps_711 = AbilitySkillId(711)
val skillFlourishesI_712 = AbilitySkillId(712)
val skillQuickstep_713 = AbilitySkillId(713)
val skillBoxStep_714 = AbilitySkillId(714)
val skillStutterStep_715 = AbilitySkillId(715)
val skillAnimatedFlourish_716 = AbilitySkillId(716)
val skillDesperateFlourish_717 = AbilitySkillId(717)
val skillReverseFlourish_718 = AbilitySkillId(718)
val skillViolentFlourish_719 = AbilitySkillId(719)
val skillBuildingFlourish_720 = AbilitySkillId(720)
val skillWildFlourish_721 = AbilitySkillId(721)
val skillTabulaRasa_722 = AbilitySkillId(722)
val skillLightArts_723 = AbilitySkillId(723)
val skillDarkArts_724 = AbilitySkillId(724)
val skillFlourishesII_725 = AbilitySkillId(725)
val skillModusVeritas_726 = AbilitySkillId(726)
val skillPenury_727 = AbilitySkillId(727)
val skillCelerity_728 = AbilitySkillId(728)
val skillRapture_729 = AbilitySkillId(729)
val skillAccession_730 = AbilitySkillId(730)
val skillParsimony_731 = AbilitySkillId(731)
val skillAlacrity_732 = AbilitySkillId(732)
val skillEbullience_733 = AbilitySkillId(733)
val skillManifestation_734 = AbilitySkillId(734)
val skillStratagems_735 = AbilitySkillId(735)
val skillVelocityShot_736 = AbilitySkillId(736)
val skillSnarl_737 = AbilitySkillId(737)
val skillRetaliation_738 = AbilitySkillId(738)
val skillFootwork_739 = AbilitySkillId(739)
val skillDespoil_740 = AbilitySkillId(740)
val skillPianissimo_741 = AbilitySkillId(741)
val skillSekkanoki_742 = AbilitySkillId(742)
val skillElementalSiphon_744 = AbilitySkillId(744)
val skillSublimation_745 = AbilitySkillId(745)
val skillAddendumWhite_746 = AbilitySkillId(746)
val skillAddendumBlack_747 = AbilitySkillId(747)
val skillCollaborator_748 = AbilitySkillId(748)
val skillSaberDance_749 = AbilitySkillId(749)
val skillFanDance_750 = AbilitySkillId(750)
val skillNoFootRise_751 = AbilitySkillId(751)
val skillAltruism_752 = AbilitySkillId(752)
val skillFocalization_753 = AbilitySkillId(753)
val skillTranquility_754 = AbilitySkillId(754)
val skillEquanimity_755 = AbilitySkillId(755)
val skillEnlightenment_756 = AbilitySkillId(756)
val skillAfflatusSolace_757 = AbilitySkillId(757)
val skillAfflatusMisery_758 = AbilitySkillId(758)
val skillComposure_759 = AbilitySkillId(759)
val skillYonin_760 = AbilitySkillId(760)
val skillInnin_761 = AbilitySkillId(761)
val skillAvatarsFavor_762 = AbilitySkillId(762)
val skillReady_763 = AbilitySkillId(763)
val skillRestraint_764 = AbilitySkillId(764)
val skillPerfectCounter_765 = AbilitySkillId(765)
val skillManaWall_766 = AbilitySkillId(766)
val skillDivineEmblem_767 = AbilitySkillId(767)
val skillNetherVoid_768 = AbilitySkillId(768)
val skillDoubleShot_769 = AbilitySkillId(769)
val skillSengikori_770 = AbilitySkillId(770)
val skillFutae_771 = AbilitySkillId(771)
val skillSpiritJump_772 = AbilitySkillId(772)
val skillPresto_773 = AbilitySkillId(773)
val skillDivineWaltzII_774 = AbilitySkillId(774)
val skillFlourishesIII_775 = AbilitySkillId(775)
val skillClimacticFlourish_776 = AbilitySkillId(776)
val skillLibra_777 = AbilitySkillId(777)
val skillTacticalSwitch_778 = AbilitySkillId(778)
val skillBloodRage_779 = AbilitySkillId(779)
val skillImpetus_781 = AbilitySkillId(781)
val skillDivineCaress_782 = AbilitySkillId(782)
val skillSacrosanctity_783 = AbilitySkillId(783)
val skillEnmityDouse_784 = AbilitySkillId(784)
val skillManawell_785 = AbilitySkillId(785)
val skillSaboteur_786 = AbilitySkillId(786)
val skillSpontaneity_787 = AbilitySkillId(787)
val skillConspirator_788 = AbilitySkillId(788)
val skillSepulcher_789 = AbilitySkillId(789)
val skillPalisade_790 = AbilitySkillId(790)
val skillArcaneCrest_791 = AbilitySkillId(791)
val skillScarletDelirium_792 = AbilitySkillId(792)
val skillSpur_793 = AbilitySkillId(793)
val skillRunWild_794 = AbilitySkillId(794)
val skillTenuto_795 = AbilitySkillId(795)
val skillMarcato_796 = AbilitySkillId(796)
val skillBountyShot_797 = AbilitySkillId(797)
val skillDecoyShot_798 = AbilitySkillId(798)
val skillHamanoha_799 = AbilitySkillId(799)
val skillHagakure_800 = AbilitySkillId(800)
val skillIssekigan_803 = AbilitySkillId(803)
val skillDragonBreaker_804 = AbilitySkillId(804)
val skillSoulJump_805 = AbilitySkillId(805)
val skillSteadyWing_807 = AbilitySkillId(807)
val skillManaCede_808 = AbilitySkillId(808)
val skillEfflux_809 = AbilitySkillId(809)
val skillUnbridledLearning_810 = AbilitySkillId(810)
val skillTripleShot_813 = AbilitySkillId(813)
val skillAlliesRoll_814 = AbilitySkillId(814)
val skillMisersRoll_815 = AbilitySkillId(815)
val skillCompanionsRoll_816 = AbilitySkillId(816)
val skillAvengersRoll_817 = AbilitySkillId(817)
val skillCooldown_821 = AbilitySkillId(821)
val skillDeusExAutomata_822 = AbilitySkillId(822)
val skillCuringWaltzV_823 = AbilitySkillId(823)
val skillFeatherStep_824 = AbilitySkillId(824)
val skillStrikingFlourish_825 = AbilitySkillId(825)
val skillTernaryFlourish_826 = AbilitySkillId(826)
val skillPerpetuance_828 = AbilitySkillId(828)
val skillImmanence_829 = AbilitySkillId(829)
val skillSmitingBreath_830 = AbilitySkillId(830)
val skillRestoringBreath_831 = AbilitySkillId(831)
val skillKonzenittai_832 = AbilitySkillId(832)
val skillBully_833 = AbilitySkillId(833)
val skillMaintenance_834 = AbilitySkillId(834)
val skillBrazenRush_835 = AbilitySkillId(835)
val skillInnerStrength_836 = AbilitySkillId(836)
val skillAsylum_837 = AbilitySkillId(837)
val skillSubtleSorcery_838 = AbilitySkillId(838)
val skillStymie_839 = AbilitySkillId(839)
val skillLarceny_840 = AbilitySkillId(840)
val skillIntervene_841 = AbilitySkillId(841)
val skillSoulEnslavement_842 = AbilitySkillId(842)
val skillUnleash_843 = AbilitySkillId(843)
val skillClarionCall_844 = AbilitySkillId(844)
val skillOverkill_845 = AbilitySkillId(845)
val skillYaegasumi_846 = AbilitySkillId(846)
val skillMikage_847 = AbilitySkillId(847)
val skillFlyHigh_848 = AbilitySkillId(848)
val skillAstralConduit_849 = AbilitySkillId(849)
val skillUnbridledWisdom_850 = AbilitySkillId(850)
val skillCuttingCards_851 = AbilitySkillId(851)
val skillHeadyArtifice_852 = AbilitySkillId(852)
val skillGrandPas_853 = AbilitySkillId(853)
val skillCaperEmissarius_854 = AbilitySkillId(854)
val skillBolster_855 = AbilitySkillId(855)
val skillSwipe_856 = AbilitySkillId(856)
val skillFullCircle_857 = AbilitySkillId(857)
val skillLastingEmanation_858 = AbilitySkillId(858)
val skillEclipticAttrition_859 = AbilitySkillId(859)
val skillCollimatedFervor_860 = AbilitySkillId(860)
val skillLifeCycle_861 = AbilitySkillId(861)
val skillBlazeofGlory_862 = AbilitySkillId(862)
val skillDematerialize_863 = AbilitySkillId(863)
val skillTheurgicFocus_864 = AbilitySkillId(864)
val skillConcentricPulse_865 = AbilitySkillId(865)
val skillMendingHalation_866 = AbilitySkillId(866)
val skillRadialArcana_867 = AbilitySkillId(867)
val skillElementalSforzo_868 = AbilitySkillId(868)
val skillRuneEnchantment_869 = AbilitySkillId(869)
val skillIgnis_870 = AbilitySkillId(870)
val skillGelus_871 = AbilitySkillId(871)
val skillFlabra_872 = AbilitySkillId(872)
val skillTellus_873 = AbilitySkillId(873)
val skillSulpor_874 = AbilitySkillId(874)
val skillUnda_875 = AbilitySkillId(875)
val skillLux_876 = AbilitySkillId(876)
val skillTenebrae_877 = AbilitySkillId(877)
val skillVallation_878 = AbilitySkillId(878)
val skillSwordplay_879 = AbilitySkillId(879)
val skillLunge_880 = AbilitySkillId(880)
val skillPflug_881 = AbilitySkillId(881)
val skillEmbolden_882 = AbilitySkillId(882)
val skillValiance_883 = AbilitySkillId(883)
val skillGambit_884 = AbilitySkillId(884)
val skillLiement_885 = AbilitySkillId(885)
val skillOneforAll_886 = AbilitySkillId(886)
val skillRayke_887 = AbilitySkillId(887)
val skillBattuta_888 = AbilitySkillId(888)
val skillWidenedCompass_889 = AbilitySkillId(889)
val skillOdyllicSubterfuge_890 = AbilitySkillId(890)
val skillWard_891 = AbilitySkillId(891)
val skillEffusion_892 = AbilitySkillId(892)
val skillChocoboJigII_893 = AbilitySkillId(893)
val skillRelinquish_894 = AbilitySkillId(894)
val skillVivaciousPulse_895 = AbilitySkillId(895)
val skillContradance_896 = AbilitySkillId(896)
val skillApogee_897 = AbilitySkillId(897)
val skillEntrust_898 = AbilitySkillId(898)
val skillBestialLoyalty_899 = AbilitySkillId(899)
val skillCascade_900 = AbilitySkillId(900)
val skillConsumeMana_901 = AbilitySkillId(901)
val skillNaturalistsRoll_902 = AbilitySkillId(902)
val skillRuneistsRoll_903 = AbilitySkillId(903)
val skillCrookedCards_904 = AbilitySkillId(904)
val skillSpiritBond_905 = AbilitySkillId(905)
val skillMajesty_906 = AbilitySkillId(906)
val skillHoverShot_907 = AbilitySkillId(907)
val skillHealingRuby_1024 = AbilitySkillId(1024)
val skillPoisonNails_1025 = AbilitySkillId(1025)
val skillShiningRuby_1026 = AbilitySkillId(1026)
val skillGlitteringRuby_1027 = AbilitySkillId(1027)
val skillMeteorite_1028 = AbilitySkillId(1028)
val skillHealingRubyII_1029 = AbilitySkillId(1029)
val skillSearingLight_1030 = AbilitySkillId(1030)
val skillHolyMist_1031 = AbilitySkillId(1031)
val skillSoothingRuby_1032 = AbilitySkillId(1032)
val skillRegalScratch_1033 = AbilitySkillId(1033)
val skillMewingLullaby_1034 = AbilitySkillId(1034)
val skillEerieEye_1035 = AbilitySkillId(1035)
val skillLevelHoly_1036 = AbilitySkillId(1036)
val skillRaiseII_1037 = AbilitySkillId(1037)
val skillReraiseII_1038 = AbilitySkillId(1038)
val skillAltanasFavor_1039 = AbilitySkillId(1039)
val skillMoonlitCharge_1040 = AbilitySkillId(1040)
val skillCrescentFang_1041 = AbilitySkillId(1041)
val skillLunarCry_1042 = AbilitySkillId(1042)
val skillLunarRoar_1043 = AbilitySkillId(1043)
val skillEclipticGrowl_1044 = AbilitySkillId(1044)
val skillEclipticHowl_1045 = AbilitySkillId(1045)
val skillEclipseBite_1046 = AbilitySkillId(1046)
val skillHowlingMoon_1048 = AbilitySkillId(1048)
val skillLunarBay_1049 = AbilitySkillId(1049)
val skillHeavenwardHowl_1050 = AbilitySkillId(1050)
val skillImpact_1051 = AbilitySkillId(1051)
val skillPunch_1056 = AbilitySkillId(1056)
val skillFireII_1057 = AbilitySkillId(1057)
val skillBurningStrike_1058 = AbilitySkillId(1058)
val skillDoublePunch_1059 = AbilitySkillId(1059)
val skillCrimsonHowl_1060 = AbilitySkillId(1060)
val skillFireIV_1061 = AbilitySkillId(1061)
val skillFlamingCrush_1062 = AbilitySkillId(1062)
val skillMeteorStrike_1063 = AbilitySkillId(1063)
val skillInferno_1064 = AbilitySkillId(1064)
val skillInfernoHowl_1065 = AbilitySkillId(1065)
val skillConflagStrike_1066 = AbilitySkillId(1066)
val skillRockThrow_1072 = AbilitySkillId(1072)
val skillStoneII_1073 = AbilitySkillId(1073)
val skillRockBuster_1074 = AbilitySkillId(1074)
val skillMegalithThrow_1075 = AbilitySkillId(1075)
val skillEarthenWard_1076 = AbilitySkillId(1076)
val skillStoneIV_1077 = AbilitySkillId(1077)
val skillMountainBuster_1078 = AbilitySkillId(1078)
val skillGeocrush_1079 = AbilitySkillId(1079)
val skillEarthenFury_1080 = AbilitySkillId(1080)
val skillEarthenArmor_1081 = AbilitySkillId(1081)
val skillCragThrow_1082 = AbilitySkillId(1082)
val skillBarracudaDive_1088 = AbilitySkillId(1088)
val skillWaterII_1089 = AbilitySkillId(1089)
val skillTailWhip_1090 = AbilitySkillId(1090)
val skillSpringWater_1091 = AbilitySkillId(1091)
val skillSlowga_1092 = AbilitySkillId(1092)
val skillWaterIV_1093 = AbilitySkillId(1093)
val skillSpinningDive_1094 = AbilitySkillId(1094)
val skillGrandFall_1095 = AbilitySkillId(1095)
val skillTidalWave_1096 = AbilitySkillId(1096)
val skillTidalRoar_1097 = AbilitySkillId(1097)
val skillSoothingCurrent_1098 = AbilitySkillId(1098)
val skillClaw_1104 = AbilitySkillId(1104)
val skillAeroII_1105 = AbilitySkillId(1105)
val skillWhisperingWind_1106 = AbilitySkillId(1106)
val skillHastega_1107 = AbilitySkillId(1107)
val skillAerialArmor_1108 = AbilitySkillId(1108)
val skillAeroIV_1109 = AbilitySkillId(1109)
val skillPredatorClaws_1110 = AbilitySkillId(1110)
val skillWindBlade_1111 = AbilitySkillId(1111)
val skillAerialBlast_1112 = AbilitySkillId(1112)
val skillFleetWind_1113 = AbilitySkillId(1113)
val skillHastegaII_1114 = AbilitySkillId(1114)
val skillAxeKick_1120 = AbilitySkillId(1120)
val skillBlizzardII_1121 = AbilitySkillId(1121)
val skillFrostArmor_1122 = AbilitySkillId(1122)
val skillSleepga_1123 = AbilitySkillId(1123)
val skillDoubleSlap_1124 = AbilitySkillId(1124)
val skillBlizzardIV_1125 = AbilitySkillId(1125)
val skillRush_1126 = AbilitySkillId(1126)
val skillHeavenlyStrike_1127 = AbilitySkillId(1127)
val skillDiamondDust_1128 = AbilitySkillId(1128)
val skillDiamondStorm_1129 = AbilitySkillId(1129)
val skillCrystalBlessing_1130 = AbilitySkillId(1130)
val skillShockStrike_1136 = AbilitySkillId(1136)
val skillThunderII_1137 = AbilitySkillId(1137)
val skillRollingThunder_1138 = AbilitySkillId(1138)
val skillThunderspark_1139 = AbilitySkillId(1139)
val skillLightningArmor_1140 = AbilitySkillId(1140)
val skillThunderIV_1141 = AbilitySkillId(1141)
val skillChaoticStrike_1142 = AbilitySkillId(1142)
val skillThunderstorm_1143 = AbilitySkillId(1143)
val skillJudgmentBolt_1144 = AbilitySkillId(1144)
val skillShockSquall_1145 = AbilitySkillId(1145)
val skillVoltStrike_1146 = AbilitySkillId(1146)
val skillHealingBreathIV_1151 = AbilitySkillId(1151)
val skillHealingBreath_1152 = AbilitySkillId(1152)
val skillHealingBreathII_1153 = AbilitySkillId(1153)
val skillHealingBreathIII_1154 = AbilitySkillId(1154)
val skillRemovePoison_1155 = AbilitySkillId(1155)
val skillRemoveBlindness_1156 = AbilitySkillId(1156)
val skillRemoveParalysis_1157 = AbilitySkillId(1157)
val skillFlameBreath_1158 = AbilitySkillId(1158)
val skillFrostBreath_1159 = AbilitySkillId(1159)
val skillGustBreath_1160 = AbilitySkillId(1160)
val skillSandBreath_1161 = AbilitySkillId(1161)
val skillLightningBreath_1162 = AbilitySkillId(1162)
val skillHydroBreath_1163 = AbilitySkillId(1163)
val skillSuperClimb_1164 = AbilitySkillId(1164)
val skillRemoveCurse_1165 = AbilitySkillId(1165)
val skillRemoveDisease_1166 = AbilitySkillId(1166)
val skillCamisado_1168 = AbilitySkillId(1168)
val skillSomnolence_1169 = AbilitySkillId(1169)
val skillNightmare_1170 = AbilitySkillId(1170)
val skillUltimateTerror_1171 = AbilitySkillId(1171)
val skillNoctoshield_1172 = AbilitySkillId(1172)
val skillDreamShroud_1173 = AbilitySkillId(1173)
val skillNetherBlast_1174 = AbilitySkillId(1174)
val skillCacodemonia_1175 = AbilitySkillId(1175)
val skillRuinousOmen_1176 = AbilitySkillId(1176)
val skillNightTerror_1177 = AbilitySkillId(1177)
val skillPavorNocturnus_1178 = AbilitySkillId(1178)
val skillBlindside_1179 = AbilitySkillId(1179)
val skillDeconstruction_1180 = AbilitySkillId(1180)
val skillChronoshift_1181 = AbilitySkillId(1181)
val skillZantetsuken_1182 = AbilitySkillId(1182)
val skillPerfectDefense_1183 = AbilitySkillId(1183)
val skillFootKick_1184 = AbilitySkillId(1184)
val skillDustCloud_1185 = AbilitySkillId(1185)
val skillWhirlClaws_1186 = AbilitySkillId(1186)
val skillHeadButt_1187 = AbilitySkillId(1187)
val skillDreamFlower_1188 = AbilitySkillId(1188)
val skillWildOats_1189 = AbilitySkillId(1189)
val skillLeafDagger_1190 = AbilitySkillId(1190)
val skillScream_1191 = AbilitySkillId(1191)
val skillRoar_1192 = AbilitySkillId(1192)
val skillRazorFang_1193 = AbilitySkillId(1193)
val skillClawCyclone_1194 = AbilitySkillId(1194)
val skillTailBlow_1195 = AbilitySkillId(1195)
val skillFireball_1196 = AbilitySkillId(1196)
val skillBlockhead_1197 = AbilitySkillId(1197)
val skillBrainCrush_1198 = AbilitySkillId(1198)
val skillInfrasonics_1199 = AbilitySkillId(1199)
val skillSecretion_1200 = AbilitySkillId(1200)
val skillLambChop_1201 = AbilitySkillId(1201)
val skillRage_1202 = AbilitySkillId(1202)
val skillSheepCharge_1203 = AbilitySkillId(1203)
val skillSheepSong_1204 = AbilitySkillId(1204)
val skillBubbleShower_1205 = AbilitySkillId(1205)
val skillBubbleCurtain_1206 = AbilitySkillId(1206)
val skillBigScissors_1207 = AbilitySkillId(1207)
val skillScissorGuard_1208 = AbilitySkillId(1208)
val skillMetallicBody_1209 = AbilitySkillId(1209)
val skillNeedleshot_1210 = AbilitySkillId(1210)
val skillNeedles_1211 = AbilitySkillId(1211)
val skillFrogkick_1212 = AbilitySkillId(1212)
val skillSpore_1213 = AbilitySkillId(1213)
val skillQueasyshroom_1214 = AbilitySkillId(1214)
val skillNumbshroom_1215 = AbilitySkillId(1215)
val skillShakeshroom_1216 = AbilitySkillId(1216)
val skillSilenceGas_1217 = AbilitySkillId(1217)
val skillDarkSpore_1218 = AbilitySkillId(1218)
val skillPowerAttack_1219 = AbilitySkillId(1219)
val skillHiFreqField_1220 = AbilitySkillId(1220)
val skillRhinoAttack_1221 = AbilitySkillId(1221)
val skillRhinoGuard_1222 = AbilitySkillId(1222)
val skillSpoil_1223 = AbilitySkillId(1223)
val skillCursedSphere_1224 = AbilitySkillId(1224)
val skillVenom_1225 = AbilitySkillId(1225)
val skillSandblast_1226 = AbilitySkillId(1226)
val skillSandpit_1227 = AbilitySkillId(1227)
val skillVenomSpray_1228 = AbilitySkillId(1228)
val skillMandibularBite_1229 = AbilitySkillId(1229)
val skillSoporific_1230 = AbilitySkillId(1230)
val skillGloeosuccus_1231 = AbilitySkillId(1231)
val skillPalsyPollen_1232 = AbilitySkillId(1232)
val skillGeistWall_1233 = AbilitySkillId(1233)
val skillNumbingNoise_1234 = AbilitySkillId(1234)
val skillNimbleSnap_1235 = AbilitySkillId(1235)
val skillCyclotail_1236 = AbilitySkillId(1236)
val skillToxicSpit_1237 = AbilitySkillId(1237)
val skillDoubleClaw_1238 = AbilitySkillId(1238)
val skillGrapple_1239 = AbilitySkillId(1239)
val skillSpinningTop_1240 = AbilitySkillId(1240)
val skillFilamentedHold_1241 = AbilitySkillId(1241)
val skillChaoticEye_1242 = AbilitySkillId(1242)
val skillBlaster_1243 = AbilitySkillId(1243)
val skillSuction_1244 = AbilitySkillId(1244)
val skillDrainkiss_1245 = AbilitySkillId(1245)
val skillSnowCloud_1246 = AbilitySkillId(1246)
val skillWildCarrot_1247 = AbilitySkillId(1247)
val skillSuddenLunge_1248 = AbilitySkillId(1248)
val skillSpiralSpin_1249 = AbilitySkillId(1249)
val skillNoisomePowder_1250 = AbilitySkillId(1250)
val skillAcidMist_1252 = AbilitySkillId(1252)
val skillTPDrainkiss_1253 = AbilitySkillId(1253)
val skillScytheTail_1255 = AbilitySkillId(1255)
val skillRipperFang_1256 = AbilitySkillId(1256)
val skillChompRush_1257 = AbilitySkillId(1257)
val skillChargedWhisker_1258 = AbilitySkillId(1258)
val skillPurulentOoze_1259 = AbilitySkillId(1259)
val skillCorrosiveOoze_1260 = AbilitySkillId(1260)
val skillBackHeel_1261 = AbilitySkillId(1261)
val skillJettatura_1262 = AbilitySkillId(1262)
val skillChokeBreath_1263 = AbilitySkillId(1263)
val skillFantod_1264 = AbilitySkillId(1264)
val skillTortoiseStomp_1265 = AbilitySkillId(1265)
val skillHardenShell_1266 = AbilitySkillId(1266)
val skillAquaBreath_1267 = AbilitySkillId(1267)
val skillWingSlap_1268 = AbilitySkillId(1268)
val skillBeakLunge_1269 = AbilitySkillId(1269)
val skillIntimidate_1270 = AbilitySkillId(1270)
val skillRecoilDive_1271 = AbilitySkillId(1271)
val skillWaterWall_1272 = AbilitySkillId(1272)
val skillSensillaBlades_1273 = AbilitySkillId(1273)
val skillTegminaBuffet_1274 = AbilitySkillId(1274)
val skillMoltingPlumage_1275 = AbilitySkillId(1275)
val skillSwoopingFrenzy_1276 = AbilitySkillId(1276)
val skillSweepingGouge_1277 = AbilitySkillId(1277)
val skillZealousSnort_1278 = AbilitySkillId(1278)
val skillPentapeck_1279 = AbilitySkillId(1279)
val skillTicklingTendrils_1280 = AbilitySkillId(1280)
val skillStinkBomb_1281 = AbilitySkillId(1281)
val skillNectarousDeluge_1282 = AbilitySkillId(1282)
val skillNepenthicPlunge_1283 = AbilitySkillId(1283)
val skillSomersault_1284 = AbilitySkillId(1284)
val skillPacifyingRuby_1285 = AbilitySkillId(1285)
val skillFoulWaters_1286 = AbilitySkillId(1286)
val skillPestilentPlume_1287 = AbilitySkillId(1287)
val skillPeckingFlurry_1288 = AbilitySkillId(1288)
val skillSickleSlash_1289 = AbilitySkillId(1289)
val skillAcidSpray_1290 = AbilitySkillId(1290)
val skillSpiderWeb_1291 = AbilitySkillId(1291)
val skillRegalGash_1292 = AbilitySkillId(1292)
val skillInfectedLeech_1293 = AbilitySkillId(1293)
val skillGloomSpray_1294 = AbilitySkillId(1294)
val skillDisembowel_1298 = AbilitySkillId(1298)
val skillExtirpatingSalvo_1299 = AbilitySkillId(1299)
val skillVenomShower_1300 = AbilitySkillId(1300)
val skillMegaScissors_1301 = AbilitySkillId(1301)
val skillFrenziedRage_1302 = AbilitySkillId(1302)
val skillRhinowrecker_1303 = AbilitySkillId(1303)
val skillFluidToss_1304 = AbilitySkillId(1304)
val skillFluidSpread_1305 = AbilitySkillId(1305)
val skillDigest_1306 = AbilitySkillId(1306)
val skillCrossthrash_1307 = AbilitySkillId(1307)
val skillPredatoryGlare_1308 = AbilitySkillId(1308)
val skillHoofVolley_1309 = AbilitySkillId(1309)
val skillNihilitySong_1310 = AbilitySkillId(1310)
val skillClarsachCall_1472 = AbilitySkillId(1472)
val skillWelt_1473 = AbilitySkillId(1473)
val skillKatabaticBlades_1474 = AbilitySkillId(1474)
val skillLunaticVoice_1475 = AbilitySkillId(1475)
val skillRoundhouse_1476 = AbilitySkillId(1476)
val skillChinook_1477 = AbilitySkillId(1477)
val skillBitterElegy_1478 = AbilitySkillId(1478)
val skillSonicBuffet_1479 = AbilitySkillId(1479)
val skillTornadoII_1480 = AbilitySkillId(1480)
val skillWindsBlessing_1481 = AbilitySkillId(1481)
val skillHystericAssault_1482 = AbilitySkillId(1482)
val skillAccuracyBonus_1537 = AbilitySkillId(1537)
val skillEvasionBonus_1538 = AbilitySkillId(1538)
val skillAttackBonus_1539 = AbilitySkillId(1539)
val skillDefenseBonus_1540 = AbilitySkillId(1540)
val skillMagicAtkBonus_1541 = AbilitySkillId(1541)
val skillMagicDefBonus_1542 = AbilitySkillId(1542)
val skillMaxHPBoost_1543 = AbilitySkillId(1543)
val skillMaxMPBoost_1544 = AbilitySkillId(1544)
val skillAutoRegen_1545 = AbilitySkillId(1545)
val skillAutoRefresh_1546 = AbilitySkillId(1546)
val skillRapidShot_1547 = AbilitySkillId(1547)
val skillFastCast_1548 = AbilitySkillId(1548)
val skillConserveMP_1549 = AbilitySkillId(1549)
val skillStoreTP_1550 = AbilitySkillId(1550)
val skillDoubleAttack_1551 = AbilitySkillId(1551)
val skillTripleAttack_1552 = AbilitySkillId(1552)
val skillCounter_1553 = AbilitySkillId(1553)
val skillDualWield_1554 = AbilitySkillId(1554)
val skillTreasureHunter_1555 = AbilitySkillId(1555)
val skillGilfinder_1556 = AbilitySkillId(1556)
val skillAlertness_1557 = AbilitySkillId(1557)
val skillStealth_1558 = AbilitySkillId(1558)
val skillMartialArts_1559 = AbilitySkillId(1559)
val skillClearMind_1560 = AbilitySkillId(1560)
val skillShieldMastery_1561 = AbilitySkillId(1561)
val skillBeastKiller_1568 = AbilitySkillId(1568)
val skillPlantoidKiller_1569 = AbilitySkillId(1569)
val skillVerminKiller_1570 = AbilitySkillId(1570)
val skillLizardKiller_1571 = AbilitySkillId(1571)
val skillBirdKiller_1572 = AbilitySkillId(1572)
val skillAmorphKiller_1573 = AbilitySkillId(1573)
val skillAquanKiller_1574 = AbilitySkillId(1574)
val skillUndeadKiller_1575 = AbilitySkillId(1575)
val skillArcanaKiller_1577 = AbilitySkillId(1577)
val skillDemonKiller_1578 = AbilitySkillId(1578)
val skillDragonKiller_1579 = AbilitySkillId(1579)
val skillResistSleep_1584 = AbilitySkillId(1584)
val skillResistPoison_1585 = AbilitySkillId(1585)
val skillResistParalyze_1586 = AbilitySkillId(1586)
val skillResistBlind_1587 = AbilitySkillId(1587)
val skillResistSilence_1588 = AbilitySkillId(1588)
val skillResistPetrify_1589 = AbilitySkillId(1589)
val skillResistVirus_1590 = AbilitySkillId(1590)
val skillResistCurse_1591 = AbilitySkillId(1591)
val skillResistStun_1592 = AbilitySkillId(1592)
val skillResistBind_1593 = AbilitySkillId(1593)
val skillResistGravity_1594 = AbilitySkillId(1594)
val skillResistSlow_1595 = AbilitySkillId(1595)
val skillResistCharm_1596 = AbilitySkillId(1596)
val skillResistAmnesia_1599 = AbilitySkillId(1599)
val skillTreasureHunterII_1600 = AbilitySkillId(1600)
val skillTreasHunterIII_1601 = AbilitySkillId(1601)
val skillKickAttacks_1602 = AbilitySkillId(1602)
val skillSubtleBlow_1603 = AbilitySkillId(1603)
val skillAssassin_1604 = AbilitySkillId(1604)
val skillDivineVeil_1605 = AbilitySkillId(1605)
val skillZanshin_1606 = AbilitySkillId(1606)
val skillSavagery_1607 = AbilitySkillId(1607)
val skillAggressiveAim_1608 = AbilitySkillId(1608)
val skillInvigorate_1609 = AbilitySkillId(1609)
val skillPenance_1610 = AbilitySkillId(1610)
val skillAuraSteal_1611 = AbilitySkillId(1611)
val skillAmbush_1612 = AbilitySkillId(1612)
val skillIronWill_1613 = AbilitySkillId(1613)
val skillGuardian_1614 = AbilitySkillId(1614)
val skillMutedSoul_1615 = AbilitySkillId(1615)
val skillDesperateBlows_1616 = AbilitySkillId(1616)
val skillBeastAffinity_1617 = AbilitySkillId(1617)
val skillBeastHealer_1618 = AbilitySkillId(1618)
val skillSnapshot_1619 = AbilitySkillId(1619)
val skillRecycle_1620 = AbilitySkillId(1620)
val skillIkishoten_1621 = AbilitySkillId(1621)
val skillOverwhelm_1622 = AbilitySkillId(1622)
val skillNinjaToolExpert_1623 = AbilitySkillId(1623)
val skillEmpathy_1624 = AbilitySkillId(1624)
val skillStrafe_1625 = AbilitySkillId(1625)
val skillEnchainment_1626 = AbilitySkillId(1626)
val skillAssimilation_1627 = AbilitySkillId(1627)
val skillWinningStreak_1628 = AbilitySkillId(1628)
val skillLoadedDeck_1629 = AbilitySkillId(1629)
val skillFineTuning_1630 = AbilitySkillId(1630)
val skillOptimization_1631 = AbilitySkillId(1631)
val skillClosedPosition_1632 = AbilitySkillId(1632)
val skillStormsurge_1633 = AbilitySkillId(1633)
val skillCritAtkBonus_1634 = AbilitySkillId(1634)
val skillCritDefBonus_1635 = AbilitySkillId(1635)
val skillTacticalParry_1636 = AbilitySkillId(1636)
val skillTacticalGuard_1637 = AbilitySkillId(1637)
val skillShieldDefBonus_1638 = AbilitySkillId(1638)
val skillStoutServant_1639 = AbilitySkillId(1639)
val skillTrueShot_1640 = AbilitySkillId(1640)
val skillBloodBoon_1641 = AbilitySkillId(1641)
val skillSkillchainBonus_1642 = AbilitySkillId(1642)
val skillFencer_1643 = AbilitySkillId(1643)
val skillConserveTP_1644 = AbilitySkillId(1644)
val skillOccultAcumen_1645 = AbilitySkillId(1645)
val skillMagBurstBonus_1646 = AbilitySkillId(1646)
val skillDivineBenison_1647 = AbilitySkillId(1647)
val skillElementalCelerity_1648 = AbilitySkillId(1648)
val skillDeadAim_1649 = AbilitySkillId(1649)
val skillTranquilHeart_1650 = AbilitySkillId(1650)
val skillStalwartSoul_1651 = AbilitySkillId(1651)
val skillCardinalChant_1652 = AbilitySkillId(1652)
val skillTenacity_1653 = AbilitySkillId(1653)
val skillInquartata_1654 = AbilitySkillId(1654)
val skillCRecantation_1655 = AbilitySkillId(1655)
val skillPrimevalZeal_1656 = AbilitySkillId(1656)
val skillInspiration_1657 = AbilitySkillId(1657)
val skillSleightofSword_1658 = AbilitySkillId(1658)
val skillDaken_1659 = AbilitySkillId(1659)
val skillSuperior_1660 = AbilitySkillId(1660)
val skillMagicAccBonus_1661 = AbilitySkillId(1661)
val skillMagicEvaBonus_1662 = AbilitySkillId(1662)
val skillSmite_1663 = AbilitySkillId(1663)
val skillDamageLimit_1665 = AbilitySkillId(1665)
val skillAnimusSolace_1666 = AbilitySkillId(1666)
val skillAnimusMisery_1667 = AbilitySkillId(1667)
val skillConAnima_1668 = AbilitySkillId(1668)
val skillConBrio_1669 = AbilitySkillId(1669)
val skillWSDamageBoost_1670 = AbilitySkillId(1670)
val skillMaxHPBoostII_1671 = AbilitySkillId(1671)
val skillShieldBarrier_1672 = AbilitySkillId(1672)
val skillTandemStrike_1673 = AbilitySkillId(1673)
val skillTandemBlow_1674 = AbilitySkillId(1674)
val skillFootKick_1793 = AbilitySkillId(1793)
val skillDustCloud_1794 = AbilitySkillId(1794)
val skillWhirlClaws_1795 = AbilitySkillId(1795)
val skillLambChop_1796 = AbilitySkillId(1796)
val skillRage_1797 = AbilitySkillId(1797)
val skillSheepCharge_1798 = AbilitySkillId(1798)
val skillSheepBleat_1799 = AbilitySkillId(1799)
val skillSheepSong_1800 = AbilitySkillId(1800)
val skillRage_1801 = AbilitySkillId(1801)
val skillRamCharge_1802 = AbilitySkillId(1802)
val skillRumble_1803 = AbilitySkillId(1803)
val skillGreatBleat_1804 = AbilitySkillId(1804)
val skillPetribreath_1805 = AbilitySkillId(1805)
val skillRoar_1806 = AbilitySkillId(1806)
val skillRazorFang_1807 = AbilitySkillId(1807)
val skillClawCyclone_1808 = AbilitySkillId(1808)
val skillSandblast_1809 = AbilitySkillId(1809)
val skillSandpit_1810 = AbilitySkillId(1810)
val skillVenomSpray_1811 = AbilitySkillId(1811)
val skillMandibularBite_1812 = AbilitySkillId(1812)
val skillSonicWave_1813 = AbilitySkillId(1813)
val skillStomping_1814 = AbilitySkillId(1814)
val skillColdStare_1815 = AbilitySkillId(1815)
val skillWhistle_1816 = AbilitySkillId(1816)
val skillBerserk_1817 = AbilitySkillId(1817)
val skillHealingBreeze_1818 = AbilitySkillId(1818)
val skillViciousClaw_1819 = AbilitySkillId(1819)
val skillStoneThrow_1820 = AbilitySkillId(1820)
val skillSpinningClaw_1821 = AbilitySkillId(1821)
val skillClawStorm_1822 = AbilitySkillId(1822)
val skillBlankGaze_1823 = AbilitySkillId(1823)
val skillEyeScratch_1824 = AbilitySkillId(1824)
val skillMagicFruit_1825 = AbilitySkillId(1825)
val skillDrillBranch_1826 = AbilitySkillId(1826)
val skillPineconeBomb_1827 = AbilitySkillId(1827)
val skillLeafstorm_1828 = AbilitySkillId(1828)
val skillEntangle_1829 = AbilitySkillId(1829)
val skillHeadButt_1830 = AbilitySkillId(1830)
val skillDreamFlower_1831 = AbilitySkillId(1831)
val skillWildOats_1832 = AbilitySkillId(1832)
val skillPhotosynthesis_1833 = AbilitySkillId(1833)
val skillLeafDagger_1834 = AbilitySkillId(1834)
val skillScream_1835 = AbilitySkillId(1835)
val skillFrogkick_1836 = AbilitySkillId(1836)
val skillSpore_1837 = AbilitySkillId(1837)
val skillQueasyshroom_1838 = AbilitySkillId(1838)
val skillNumbshroom_1839 = AbilitySkillId(1839)
val skillShakeshroom_1840 = AbilitySkillId(1840)
val skillSilenceGas_1841 = AbilitySkillId(1841)
val skillDarkSpore_1842 = AbilitySkillId(1842)
val skillImpale_1843 = AbilitySkillId(1843)
val skillVampiricLash_1844 = AbilitySkillId(1844)
val skillSomersault_1845 = AbilitySkillId(1845)
val skillBadBreath_1846 = AbilitySkillId(1846)
val skillSweetBreath_1847 = AbilitySkillId(1847)
val skillNeedleshot_1848 = AbilitySkillId(1848)
val skill1000Needles_1849 = AbilitySkillId(1849)
val skillWildCarrot_1850 = AbilitySkillId(1850)
val skillPhotosynthesis_1851 = AbilitySkillId(1851)
val skillRandomKiss_1852 = AbilitySkillId(1852)
val skillAbsorbingKiss_1853 = AbilitySkillId(1853)
val skillDeepKiss_1854 = AbilitySkillId(1854)
val skillSharpSting_1855 = AbilitySkillId(1855)
val skillPollen_1856 = AbilitySkillId(1856)
val skillFinalSting_1857 = AbilitySkillId(1857)
val skillPowerAttack_1858 = AbilitySkillId(1858)
val skillHiFreqField_1859 = AbilitySkillId(1859)
val skillRhinoAttack_1860 = AbilitySkillId(1860)
val skillRhinoGuard_1861 = AbilitySkillId(1861)
val skillSpoil_1862 = AbilitySkillId(1862)
val skillStickyThread_1863 = AbilitySkillId(1863)
val skillPoisonBreath_1864 = AbilitySkillId(1864)
val skillCocoon_1865 = AbilitySkillId(1865)
val skillNumbingBreath_1866 = AbilitySkillId(1866)
val skillColdBreath_1867 = AbilitySkillId(1867)
val skillMandibleBite_1868 = AbilitySkillId(1868)
val skillPoisonSting_1869 = AbilitySkillId(1869)
val skillDeathScissors_1870 = AbilitySkillId(1870)
val skillWildRage_1871 = AbilitySkillId(1871)
val skillEarthPounder_1872 = AbilitySkillId(1872)
val skillSharpStrike_1873 = AbilitySkillId(1873)
val skillDoubleClaw_1874 = AbilitySkillId(1874)
val skillGrapple_1875 = AbilitySkillId(1875)
val skillFilamentedHold_1876 = AbilitySkillId(1876)
val skillSpinningTop_1877 = AbilitySkillId(1877)
val skillTailBlow_1878 = AbilitySkillId(1878)
val skillFireball_1879 = AbilitySkillId(1879)
val skillBlockhead_1880 = AbilitySkillId(1880)
val skillBrainCrush_1881 = AbilitySkillId(1881)
val skillBalefulGaze_1882 = AbilitySkillId(1882)
val skillPlaguebreath_1883 = AbilitySkillId(1883)
val skillInfrasonics_1884 = AbilitySkillId(1884)
val skillSecretion_1885 = AbilitySkillId(1885)
val skillRipperFang_1886 = AbilitySkillId(1886)
val skillFoulBreath_1887 = AbilitySkillId(1887)
val skillFrostBreath_1888 = AbilitySkillId(1888)
val skillThunderbolt_1889 = AbilitySkillId(1889)
val skillChompRush_1890 = AbilitySkillId(1890)
val skillScytheTail_1891 = AbilitySkillId(1891)
val skillTailRoll_1892 = AbilitySkillId(1892)
val skillTusk_1893 = AbilitySkillId(1893)
val skillScutum_1894 = AbilitySkillId(1894)
val skillBoneCrunch_1895 = AbilitySkillId(1895)
val skillAwfulEye_1896 = AbilitySkillId(1896)
val skillHeavyBellow_1897 = AbilitySkillId(1897)
val skillUltrasonics_1898 = AbilitySkillId(1898)
val skillSonicBoom_1899 = AbilitySkillId(1899)
val skillBloodDrain_1900 = AbilitySkillId(1900)
val skillJetStream_1901 = AbilitySkillId(1901)
val skillBlindVortex_1902 = AbilitySkillId(1902)
val skillGigaScream_1903 = AbilitySkillId(1903)
val skillDreadDive_1904 = AbilitySkillId(1904)
val skillFeatherBarrier_1905 = AbilitySkillId(1905)
val skillStormwind_1906 = AbilitySkillId(1906)
val skillHammerBeak_1907 = AbilitySkillId(1907)
val skillPoisonPick_1908 = AbilitySkillId(1908)
val skillSoundVacuum_1909 = AbilitySkillId(1909)
val skillSoundBlast_1910 = AbilitySkillId(1910)
val skillBalefulGaze_1911 = AbilitySkillId(1911)
val skillSuction_1912 = AbilitySkillId(1912)
val skillAcidMist_1913 = AbilitySkillId(1913)
val skillSandBreath_1914 = AbilitySkillId(1914)
val skillDrainkiss_1915 = AbilitySkillId(1915)
val skillRegeneration_1916 = AbilitySkillId(1916)
val skillTPDrainkiss_1917 = AbilitySkillId(1917)
val skillMPDrainkiss_1918 = AbilitySkillId(1918)
val skillBrainDrain_1919 = AbilitySkillId(1919)
val skillFluidSpread_1920 = AbilitySkillId(1920)
val skillFluidToss_1921 = AbilitySkillId(1921)
val skillDigest_1922 = AbilitySkillId(1922)
val skillSoporific_1923 = AbilitySkillId(1923)
val skillPalsyPollen_1924 = AbilitySkillId(1924)
val skillGloeosuccus_1925 = AbilitySkillId(1925)
val skillDeathRay_1926 = AbilitySkillId(1926)
val skillHexEye_1927 = AbilitySkillId(1927)
val skillPetroGaze_1928 = AbilitySkillId(1928)
val skillCatharsis_1929 = AbilitySkillId(1929)
val skillBubbleShower_1930 = AbilitySkillId(1930)
val skillBubbleCurtain_1931 = AbilitySkillId(1931)
val skillBigScissors_1932 = AbilitySkillId(1932)
val skillScissorGuard_1933 = AbilitySkillId(1933)
val skillMetallicBody_1934 = AbilitySkillId(1934)
val skillIntimidate_1935 = AbilitySkillId(1935)
val skillAquaBall_1936 = AbilitySkillId(1936)
val skillSplashBreath_1937 = AbilitySkillId(1937)
val skillScrewdriver_1938 = AbilitySkillId(1938)
val skillWaterWall_1939 = AbilitySkillId(1939)
val skillWaterShield_1940 = AbilitySkillId(1940)
val skillTentacle_1941 = AbilitySkillId(1941)
val skillInkJet_1942 = AbilitySkillId(1942)
val skillHardMembrane_1943 = AbilitySkillId(1943)
val skillCrossAttack_1944 = AbilitySkillId(1944)
val skillRegeneration_1945 = AbilitySkillId(1945)
val skillMaelstrom_1946 = AbilitySkillId(1946)
val skillWhirlwind_1947 = AbilitySkillId(1947)
val skillPetriBreath_1948 = AbilitySkillId(1948)
val skillFrenziedRage_1949 = AbilitySkillId(1949)
val skillPounce_1950 = AbilitySkillId(1950)
val skillChargedWhisker_1951 = AbilitySkillId(1951)
val skillRampantGnaw_1952 = AbilitySkillId(1952)
val skillBigHorn_1953 = AbilitySkillId(1953)
val skillSnort_1954 = AbilitySkillId(1954)
val skillRapidDance_1955 = AbilitySkillId(1955)
val skillLowing_1956 = AbilitySkillId(1956)
val skillGasShell_1957 = AbilitySkillId(1957)
val skillVenomShell_1958 = AbilitySkillId(1958)
val skillPalsynyxis_1959 = AbilitySkillId(1959)
val skillPainfulWhip_1960 = AbilitySkillId(1960)
val skillSuctorialTentacle_1961 = AbilitySkillId(1961)
val skillToxicSpit_1962 = AbilitySkillId(1962)
val skillGeistWall_1963 = AbilitySkillId(1963)
val skillNumbingNoise_1964 = AbilitySkillId(1964)
val skillNimbleSnap_1965 = AbilitySkillId(1965)
val skillCyclotail_1966 = AbilitySkillId(1966)
val skillBackHeel_1967 = AbilitySkillId(1967)
val skillJettatura_1968 = AbilitySkillId(1968)
val skillNihilitySong_1969 = AbilitySkillId(1969)
val skillChokeBreath_1970 = AbilitySkillId(1970)
val skillFantod_1971 = AbilitySkillId(1971)
val skillBlow_1972 = AbilitySkillId(1972)
val skillBeatdown_1973 = AbilitySkillId(1973)
val skillUppercut_1974 = AbilitySkillId(1974)
val skillBlankGaze_1975 = AbilitySkillId(1975)
val skillAntiphase_1976 = AbilitySkillId(1976)
val skillSnowball_1977 = AbilitySkillId(1977)
val skillHelldive_1978 = AbilitySkillId(1978)
val skillWingCutter_1979 = AbilitySkillId(1979)
val skillWildHorn_1980 = AbilitySkillId(1980)
val skillThunderbolt_1981 = AbilitySkillId(1981)
val skillShockWave_1982 = AbilitySkillId(1982)
val skillFlameArmor_1983 = AbilitySkillId(1983)
val skillHowl_1984 = AbilitySkillId(1984)
val skillMeteor_1985 = AbilitySkillId(1985)
val skillRecoilDive_1986 = AbilitySkillId(1986)
val skillBlaster_1987 = AbilitySkillId(1987)
val skillChaoticEye_1988 = AbilitySkillId(1988)
val skillCursedSphere_1989 = AbilitySkillId(1989)
val skillVenom_1990 = AbilitySkillId(1990)
val skillSnowCloud_1991 = AbilitySkillId(1991)
val skillSproutSpin_1992 = AbilitySkillId(1992)
val skillSlumberPowder_1993 = AbilitySkillId(1993)
val skillSproutSmack_1994 = AbilitySkillId(1994)
val skillVenomBreath_1995 = AbilitySkillId(1995)
val skillCriticalBite_1996 = AbilitySkillId(1996)
val skillVenomSting_1997 = AbilitySkillId(1997)
val skillStasis_1998 = AbilitySkillId(1998)
val skillVenomStorm_1999 = AbilitySkillId(1999)
val skillEarthbreaker_2000 = AbilitySkillId(2000)
val skillEvasion_2001 = AbilitySkillId(2001)
val skillDeadlyHold_2002 = AbilitySkillId(2002)
val skillTailSwing_2003 = AbilitySkillId(2003)
val skillTailSmash_2004 = AbilitySkillId(2004)
val skillHeatBreath_2005 = AbilitySkillId(2005)
val skillRiddle_2006 = AbilitySkillId(2006)
val skillGreatSandstorm_2007 = AbilitySkillId(2007)
val skillGreatWhirlwind_2008 = AbilitySkillId(2008)
val skillTortoiseSong_2009 = AbilitySkillId(2009)
val skillHeadButt_2010 = AbilitySkillId(2010)
val skillTortoiseStomp_2011 = AbilitySkillId(2011)
val skillHardenShell_2012 = AbilitySkillId(2012)
val skillEarthBreath_2013 = AbilitySkillId(2013)
val skillAquaBreath_2014 = AbilitySkillId(2014)
val skillSickleSlash_2015 = AbilitySkillId(2015)
val skillAcidSpray_2016 = AbilitySkillId(2016)
val skillSpiderWeb_2017 = AbilitySkillId(2017)
val skillArborStorm_2018 = AbilitySkillId(2018)
val skill10000Needles_2019 = AbilitySkillId(2019)
val skillSubsonics_2020 = AbilitySkillId(2020)
val skillMarrowDrain_2021 = AbilitySkillId(2021)
val skillSlipstream_2022 = AbilitySkillId(2022)
val skillTurbulence_2023 = AbilitySkillId(2023)
val skillBroadBarrage_2024 = AbilitySkillId(2024)
val skillBlindBarrage_2025 = AbilitySkillId(2025)
val skillDamnationDive_2026 = AbilitySkillId(2026)
val skillMucusSpread_2027 = AbilitySkillId(2027)
val skillEpoxySpread_2028 = AbilitySkillId(2028)
val skillDebilitatingDrone_2029 = AbilitySkillId(2029)
val skillHoofVolley_2030 = AbilitySkillId(2030)
val skillConTransfer_2031 = AbilitySkillId(2031)
val skillToxicPick_2032 = AbilitySkillId(2032)
val skillCrossthrash_2033 = AbilitySkillId(2033)
val skillKnifeEdgeCircle_2034 = AbilitySkillId(2034)
val skillTrainFall_2035 = AbilitySkillId(2035)
val skillViscidSecretion_2036 = AbilitySkillId(2036)
val skillWildGinseng_2037 = AbilitySkillId(2037)
val skillHungryCrunch_2038 = AbilitySkillId(2038)
val skillMightySnort_2039 = AbilitySkillId(2039)
val skillSoulAccretion_2040 = AbilitySkillId(2040)
val skillMiasmicBreath_2041 = AbilitySkillId(2041)
val skillPutridBreath_2042 = AbilitySkillId(2042)
val skill2000Needles_2043 = AbilitySkillId(2043)
val skill4000Needles_2044 = AbilitySkillId(2044)
val skillPredatoryGlare_2045 = AbilitySkillId(2045)
val skillVileBelch_2046 = AbilitySkillId(2046)
val skillHypnicLamp_2047 = AbilitySkillId(2047)
val skillSeismicTail_2048 = AbilitySkillId(2048)
val skillSeaspray_2049 = AbilitySkillId(2049)
val skillLeechingCurrent_2050 = AbilitySkillId(2050)
val skillPeckingFlurry_2051 = AbilitySkillId(2051)
val skillSnatchMorsel_2052 = AbilitySkillId(2052)
val skillFeatherTickle_2053 = AbilitySkillId(2053)
val skillBarrierTusk_2054 = AbilitySkillId(2054)
val skillOnrush_2055 = AbilitySkillId(2055)
val skillStampede_2056 = AbilitySkillId(2056)
val skillFlailingTrunk_2057 = AbilitySkillId(2057)
val skillVoraciousTrunk_2058 = AbilitySkillId(2058)
val skillProboscisShower_2059 = AbilitySkillId(2059)
val skillYawn_2060 = AbilitySkillId(2060)
val skillWingSlap_2061 = AbilitySkillId(2061)
val skillBeakLunge_2062 = AbilitySkillId(2062)
val skillFrigidShuffle_2063 = AbilitySkillId(2063)
val skillWingWhirl_2064 = AbilitySkillId(2064)
val skillLavaSpit_2065 = AbilitySkillId(2065)
val skillSulfurousBreath_2066 = AbilitySkillId(2066)
val skillUlulation_2067 = AbilitySkillId(2067)
val skillMagmaHoplon_2068 = AbilitySkillId(2068)
val skillGatesofHades_2069 = AbilitySkillId(2069)
val skillIncinerate_2070 = AbilitySkillId(2070)
val skillVampiricRoot_2071 = AbilitySkillId(2071)
val skillAmberScutum_2072 = AbilitySkillId(2072)
val skillVitriolicSpray_2073 = AbilitySkillId(2073)
val skillThermalPulse_2074 = AbilitySkillId(2074)
val skillCannonball_2075 = AbilitySkillId(2075)
val skillHeatBarrier_2076 = AbilitySkillId(2076)
val skillVitriolicShower_2077 = AbilitySkillId(2077)
val skillAmplification_2078 = AbilitySkillId(2078)
val skillBoilingPoint_2079 = AbilitySkillId(2079)
val skillXenoglossia_2080 = AbilitySkillId(2080)
val skillAmorphicSpikes_2081 = AbilitySkillId(2081)
val skillAmorphicScythe_2082 = AbilitySkillId(2082)
val skillSynergism_2083 = AbilitySkillId(2083)
val skillFeebleBleat_2084 = AbilitySkillId(2084)
val skillFrenzyPollen_2085 = AbilitySkillId(2085)
val skillMagmaFan_2086 = AbilitySkillId(2086)
val skillErraticFlutter_2087 = AbilitySkillId(2087)
val skillProboscis_2088 = AbilitySkillId(2088)
val skillErosionDust_2089 = AbilitySkillId(2089)
val skillExuviation_2090 = AbilitySkillId(2090)
val skillFireBreak_2091 = AbilitySkillId(2091)
val skillAbominableBelch_2092 = AbilitySkillId(2092)
val skillBatterhorn_2093 = AbilitySkillId(2093)
val skillDemoralizingRoar_2094 = AbilitySkillId(2094)
val skillBoilingBlood_2095 = AbilitySkillId(2095)
val skillGraniteSkin_2096 = AbilitySkillId(2096)
val skillCripplingSlam_2097 = AbilitySkillId(2097)
val skillAquaFortis_2098 = AbilitySkillId(2098)
val skillRegurgitation_2099 = AbilitySkillId(2099)
val skillDeltaThrust_2100 = AbilitySkillId(2100)
val skillTorpefyingCharge_2101 = AbilitySkillId(2101)
val skillCalcifyingMist_2102 = AbilitySkillId(2102)
val skillInsipidNip_2103 = AbilitySkillId(2103)
val skillPandemicNip_2104 = AbilitySkillId(2104)
val skillBombilation_2105 = AbilitySkillId(2105)
val skillCimicineDischarge_2106 = AbilitySkillId(2106)
val skillEmeticDischarge_2107 = AbilitySkillId(2107)
val skillSeedspray_2108 = AbilitySkillId(2108)
val skillViscidEmission_2109 = AbilitySkillId(2109)
val skillRottenStench_2110 = AbilitySkillId(2110)
val skillBloodyCaress_2111 = AbilitySkillId(2111)
val skillFeveredPitch_2112 = AbilitySkillId(2112)
val skillPleniluneEmbrace_2113 = AbilitySkillId(2113)
val skillPleniluneEmbrace_2114 = AbilitySkillId(2114)
val skillNoxBlast_2115 = AbilitySkillId(2115)
val skillAsuranClaws_2116 = AbilitySkillId(2116)
val skillCacophony_2117 = AbilitySkillId(2117)
val skillSuddenLunge_2118 = AbilitySkillId(2118)
val skillNoisomePowder_2119 = AbilitySkillId(2119)
val skillNepentheanHum_2120 = AbilitySkillId(2120)
val skillSpiralSpin_2121 = AbilitySkillId(2121)
val skillSpiralBurst_2122 = AbilitySkillId(2122)
val skillFuscousOoze_2123 = AbilitySkillId(2123)
val skillPurulentOoze_2124 = AbilitySkillId(2124)
val skillCorrosiveOoze_2125 = AbilitySkillId(2125)
val skillMucilOoze_2126 = AbilitySkillId(2126)
val skillDustvoid_2127 = AbilitySkillId(2127)
val skillSlaverousGale_2128 = AbilitySkillId(2128)
val skillAeolianVoid_2129 = AbilitySkillId(2129)
val skillExPurgation_2130 = AbilitySkillId(2130)
val skillDesiccation_2131 = AbilitySkillId(2131)
val skillDisorientingWaul_2132 = AbilitySkillId(2132)
val skillMicrospores_2133 = AbilitySkillId(2133)
val skillBlinkofPeril_2134 = AbilitySkillId(2134)
val skillPetalPirouette_2135 = AbilitySkillId(2135)
val skillHellScissors_2136 = AbilitySkillId(2136)
val skillFatalScream_2137 = AbilitySkillId(2137)
val skillAmnesicBlast_2138 = AbilitySkillId(2138)
val skillDemonicFlower_2139 = AbilitySkillId(2139)
val skillBloodyBeak_2140 = AbilitySkillId(2140)
val skillWarpedWail_2141 = AbilitySkillId(2141)
val skillReavingWind_2142 = AbilitySkillId(2142)
val skillStormWing_2143 = AbilitySkillId(2143)
val skillCalamitousWind_2144 = AbilitySkillId(2144)
val skillSeveringFang_2145 = AbilitySkillId(2145)
val skillAquaBlast_2146 = AbilitySkillId(2146)
val skillFrozenMist_2147 = AbilitySkillId(2147)
val skillHydroWave_2148 = AbilitySkillId(2148)
val skillIceGuillotine_2149 = AbilitySkillId(2149)
val skillAquaCannon_2150 = AbilitySkillId(2150)
val skillVenomShower_2151 = AbilitySkillId(2151)
val skillMegaScissors_2152 = AbilitySkillId(2152)
val skillCytokinesis_2153 = AbilitySkillId(2153)
val skillGraviticHorn_2154 = AbilitySkillId(2154)
val skillQuakeBlast_2155 = AbilitySkillId(2155)
val skillFluidSpread_2156 = AbilitySkillId(2156)
val skillFluidToss_2157 = AbilitySkillId(2157)
val skillDissolve_2158 = AbilitySkillId(2158)
val skillMucusSpread_2159 = AbilitySkillId(2159)
val skillEpoxySpread_2160 = AbilitySkillId(2160)
val skillThousandSpears_2161 = AbilitySkillId(2161)
val skillPhaeosynthesis_2162 = AbilitySkillId(2162)
val skillTestudoTremor_2163 = AbilitySkillId(2163)
val skillEclipticMeteor_2164 = AbilitySkillId(2164)
val skillTepalTwist_2165 = AbilitySkillId(2165)
val skillBloomFouette_2166 = AbilitySkillId(2166)
val skillPetalbackSpin_2167 = AbilitySkillId(2167)
val skillMortalBlast_2168 = AbilitySkillId(2168)
val skillGorge_2169 = AbilitySkillId(2169)
val skillDisgorge_2170 = AbilitySkillId(2170)
val skillAgaricus_2171 = AbilitySkillId(2171)
val skillTerminalSting_2172 = AbilitySkillId(2172)
val skillBoomingBleat_2173 = AbilitySkillId(2173)
val skillVacantGaze_2174 = AbilitySkillId(2174)
val skillPsycheSuction_2175 = AbilitySkillId(2175)
val skillVermilionWind_2176 = AbilitySkillId(2176)
val skillTyrantTusk_2177 = AbilitySkillId(2177)
val skillVirulentHaze_2178 = AbilitySkillId(2178)
val skillTormentTusk_2179 = AbilitySkillId(2179)
val skillTarsalSlam_2180 = AbilitySkillId(2180)
val skillAcheronFlame_2181 = AbilitySkillId(2181)
val skillDreadWind_2182 = AbilitySkillId(2182)
val skillTelsonicTempest_2183 = AbilitySkillId(2183)
val skillPreterGleam_2184 = AbilitySkillId(2184)
val skillChupaBlossom_2185 = AbilitySkillId(2185)
val skillBlightedBouquet_2186 = AbilitySkillId(2186)
val skillBoomingBomb_2187 = AbilitySkillId(2187)
val skillGushoGoo_2188 = AbilitySkillId(2188)
val skillYawn_2189 = AbilitySkillId(2189)
val skillWingSlap_2190 = AbilitySkillId(2190)
val skillBeakLunge_2191 = AbilitySkillId(2191)
val skillFrigidShuffle_2192 = AbilitySkillId(2192)
val skillWingWhirl_2193 = AbilitySkillId(2193)
val skillWhiteout_2194 = AbilitySkillId(2194)
val skillKeratinousCrush_2195 = AbilitySkillId(2195)
val skillRhinowrecker_2196 = AbilitySkillId(2196)
val skillTropicTenor_2197 = AbilitySkillId(2197)
val skillSearingEffulgence_2198 = AbilitySkillId(2198)
val skillTarichutoxin_2199 = AbilitySkillId(2199)
val skillCaliginosity_2200 = AbilitySkillId(2200)
val skillNatMeditation_2201 = AbilitySkillId(2201)
val skillSensillaBlades_2202 = AbilitySkillId(2202)
val skillTegminaBuffet_2203 = AbilitySkillId(2203)
val skillSanguinarySlash_2204 = AbilitySkillId(2204)
val skillOrthopterror_2205 = AbilitySkillId(2205)
val skillTempUpheaval_2206 = AbilitySkillId(2206)
val skillSlicenDice_2207 = AbilitySkillId(2207)
val skillBlackout_2208 = AbilitySkillId(2208)
val skillSmouldSwarm_2209 = AbilitySkillId(2209)
val skillFoulWaters_2210 = AbilitySkillId(2210)
val skillPestilentPlume_2211 = AbilitySkillId(2211)
val skillDeadeningHaze_2212 = AbilitySkillId(2212)
val skillVenomousVapor_2213 = AbilitySkillId(2213)
val skillRetinalGlare_2214 = AbilitySkillId(2214)
val skillSylvanSlumber_2215 = AbilitySkillId(2215)
val skillCrushingGaze_2216 = AbilitySkillId(2216)
val skillVaskania_2217 = AbilitySkillId(2217)
val skillWhirlingInferno_2218 = AbilitySkillId(2218)
val skillBenumbingBlaze_2219 = AbilitySkillId(2219)
val skillFightingStance_2220 = AbilitySkillId(2220)
val skillFightingStance_2221 = AbilitySkillId(2221)
val skillFightingStance_2222 = AbilitySkillId(2222)
val skillFightingStance_2223 = AbilitySkillId(2223)
val skillFrizz_2224 = AbilitySkillId(2224)
val skillJitteringJig_2225 = AbilitySkillId(2225)
val skillRomp_2226 = AbilitySkillId(2226)
val skillFreneticFlurry_2227 = AbilitySkillId(2227)